<p-toolbar id="app-header" styleClass="app-header" (mouseenter)="hideAllOverlays()">
    <div class="p-toolbar-group-left">
        @if (currentUserInitialized()) {
            <a [routerLink]="'/'">
                <img src="images/app-logo.svg" id="app-logo" alt="app-logo" />
                <div>
                    <p id="app-title">YX Admin</p>
                    <p id="app-subtitle">Transnetyx</p>
                </div>
            </a>
        }
    </div>

    <div class="p-toolbar-group-center">
        <h3 [hidden]="!currentUserFirstName()">Welcome Back, {{ currentUserFirstName() }}!</h3>
    </div>

    <div class="p-toolbar-group-right">
        @if (currentUserInitialized()) {
            <app-toolbar-account></app-toolbar-account>
        }
    </div>
</p-toolbar>

@if (currentUserInitialized()) {
    <div id="app-navigation">
        @for (item of appNavigation; track item) {
            @if (item.internalRoute) {
                <a
                    (mouseenter)="navItemHover(item.id, $event)"
                    class="nav-item"
                    [id]="'nav-item-' + item.id"
                    [routerLink]="item.url"
                    [routerLinkActive]="['active-link']"
                    [routerLinkActiveOptions]="{ exact: false }">
                    <span>{{ item.name }}</span>
                </a>
            } @else {
                <a
                    (mouseenter)="navItemHover(item.id, $event)"
                    class="nav-item"
                    [id]="'nav-item-' + item.id"
                    [href]="item.url"
                    [target]="'blank'">
                    <span>{{ item.name }}</span>
                </a>
            }
        }
    </div>
}

<ng-template #submenuTemplate let-menuItems>
    @for (submenu of menuItems; track submenu) {
        @if (submenu.internalRoute) {
            <a [routerLink]="submenu.url" [id]="submenu.id">{{ submenu.name }}</a>
        } @else {
            <a [href]="submenu.url" [id]="submenu.id" [target]="'blank'">{{ submenu.name }}</a>
        }
    }
</ng-template>

<p-popover #ovAccounts styleClass="app-header-overlay">
    <div (mouseleave)="hideAllOverlays()" class="app-header-overlay">
        <div class="overlay-body">
            <ng-container
                [ngTemplateOutlet]="submenuTemplate"
                [ngTemplateOutletContext]="{ $implicit: appNavigation[1]?.submenu }"></ng-container>
        </div>
    </div>
</p-popover>

<p-popover #ovAssays styleClass="app-header-overlay" [focusOnShow]="true">
    <div (mouseleave)="hideAllOverlays()" class="app-header-overlay">
        <div class="overlay-body">
            <ng-container
                [ngTemplateOutlet]="submenuTemplate"
                [ngTemplateOutletContext]="{ $implicit: appNavigation[2]?.submenu }"></ng-container>
        </div>
    </div>
</p-popover>

<p-popover #ovOrders styleClass="app-header-overlay" [focusOnShow]="true">
    <div (mouseleave)="hideAllOverlays()" class="app-header-overlay">
        <div class="overlay-body">
            <ng-container
                [ngTemplateOutlet]="submenuTemplate"
                [ngTemplateOutletContext]="{ $implicit: appNavigation[3]?.submenu }"></ng-container>
        </div>
    </div>
</p-popover>

<p-popover #ovPricing styleClass="app-header-overlay" [focusOnShow]="true">
    <div (mouseleave)="hideAllOverlays()" class="app-header-overlay">
        <div class="overlay-body">
            <ng-container
                [ngTemplateOutlet]="submenuTemplate"
                [ngTemplateOutletContext]="{ $implicit: appNavigation[4]?.submenu }"></ng-container>
        </div>
    </div>
</p-popover>

<p-popover #ovProbes styleClass="app-header-overlay" [focusOnShow]="true">
    <div (mouseleave)="hideAllOverlays()" class="app-header-overlay">
        <div class="overlay-body">
            <ng-container
                [ngTemplateOutlet]="submenuTemplate"
                [ngTemplateOutletContext]="{ $implicit: appNavigation[5]?.submenu }"></ng-container>
        </div>
    </div>
</p-popover>

<p-popover #ovPm styleClass="app-header-overlay" [focusOnShow]="true">
    <div (mouseleave)="hideAllOverlays()" class="app-header-overlay">
        <div class="overlay-body">
            <ng-container
                [ngTemplateOutlet]="submenuTemplate"
                [ngTemplateOutletContext]="{ $implicit: appNavigation[6]?.submenu }"></ng-container>
        </div>
    </div>
</p-popover>

<p-popover #ovSales styleClass="app-header-overlay" [focusOnShow]="true">
    <div (mouseleave)="hideAllOverlays()" class="app-header-overlay">
        <div class="overlay-body">
            <ng-container
                [ngTemplateOutlet]="submenuTemplate"
                [ngTemplateOutletContext]="{ $implicit: appNavigation[7]?.submenu }"></ng-container>
        </div>
    </div>
</p-popover>

<p-popover #ovShipping styleClass="app-header-overlay" [focusOnShow]="true">
    <div (mouseleave)="hideAllOverlays()" class="app-header-overlay">
        <div class="overlay-body">
            <ng-container
                [ngTemplateOutlet]="submenuTemplate"
                [ngTemplateOutletContext]="{ $implicit: appNavigation[8]?.submenu }"></ng-container>
        </div>
    </div>
</p-popover>

<p-popover #ovCheckmate styleClass="app-header-overlay" [focusOnShow]="true">
    <div (mouseleave)="hideAllOverlays()" class="app-header-overlay">
        <div class="overlay-body">
            <ng-container
                [ngTemplateOutlet]="submenuTemplate"
                [ngTemplateOutletContext]="{ $implicit: appNavigation[9]?.submenu }"></ng-container>
        </div>
    </div>
</p-popover>

<p-popover #ovSequencing styleClass="app-header-overlay" [focusOnShow]="true">
    <div (mouseleave)="hideAllOverlays()" class="app-header-overlay">
        <div class="overlay-body">
            <ng-container
                [ngTemplateOutlet]="submenuTemplate"
                [ngTemplateOutletContext]="{ $implicit: appNavigation[10]?.submenu }"></ng-container>
        </div>
    </div>
</p-popover>

<p-popover #ovStrains styleClass="app-header-overlay" [focusOnShow]="true">
    <div (mouseleave)="hideAllOverlays()" class="app-header-overlay">
        <div class="overlay-body">
            <ng-container
                [ngTemplateOutlet]="submenuTemplate"
                [ngTemplateOutletContext]="{ $implicit: appNavigation[11]?.submenu }"></ng-container>
        </div>
    </div>
</p-popover>

<p-popover #ovTagCenter styleClass="app-header-overlay" [focusOnShow]="true">
    <div (mouseleave)="hideAllOverlays()" class="app-header-overlay">
        <div class="overlay-body">
            <ng-container
                [ngTemplateOutlet]="submenuTemplate"
                [ngTemplateOutletContext]="{ $implicit: appNavigation[12]?.submenu }"></ng-container>
        </div>
    </div>
</p-popover>
